import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import PoliceBook from "@/modules/police-books/PoliceBook.vue";


let routes = [
    {
        path: 'police_book',
        name: 'police_book',
        component: PoliceBook,
        meta: {
            requiresAuth: true
        }
    },
];

export default {
    menuItem: new MenuItem('/police_book', i18n.t('Police book'), 40, 'chart-bar', []),
    routes: routes
}
